import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../styles/HeroCustom.scss';
import AnimatedText from '../home/AnimatedText';
import BackgroundSlider from '../home/BackgroundSlider';

const HeroCustom: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="hero-container position-relative">
      <BackgroundSlider />
      <div className="hero-gradient-overlay" />
      <div className="hero-content d-flex align-items-center">
        <div className="header-bar me-3"></div>
        <h1 className="hero-title mb-0">{t('about.hero.title')}</h1>
      </div>

      {/* White Slanted Bottom Div */}
      {/* <div className="hero-bottom-white" /> */}

    </div>
  );
};

export default HeroCustom; 